export default __webpack_public_path__ + "static/media/scrimmage.53877a62.jpg";